import Swiper, { EffectFade, Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/autoplay'
export class IndexInterviewSlider {
  constructor() {
    if (document.querySelector('.js-interview_pic') === null) return
    const interviewList = Array.prototype.slice.call(document.querySelectorAll('.js-interview_pic'), 0)
    interviewList.forEach((elm) => {
      let interviewSlider = new Swiper(elm, {
        modules: [EffectFade, Autoplay],
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        speed: 3000,
        autoplay: {
          delay: elm.getAttribute('data-delay'),
        },
      })
    })
  }
}
